import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import ClientViewHeader from 'react/member/card/components/client_view/ClientViewHeader';
import ClientViewTabs from 'react/member/card/components/client_view/ClientViewTabs';
import theme from 'react/shared/theme/Theme';

export default function ClientViewIndex({ personId }) {
  const queryClient = useMemo(() => new QueryClient(), []);

  return (
    <QueryClientProvider client={queryClient}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <div className="client-view-index">
            <ClientViewHeader personId={personId} />
            <ClientViewTabs personId={personId} />
          </div>
        </ThemeProvider>
      </StyledEngineProvider>
    </QueryClientProvider>
  );
}

ClientViewIndex.propTypes = {
  personId: PropTypes.string.isRequired,
};
